import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Fragment, useContext, useMemo } from 'react'
import { useFieldArray } from 'react-hook-form';
import { ProviderExpensePlan } from './FundExpensesPlanForm';
import { TextFieldInputNumber } from '../Ticket/fnTickit';

export default function TableHookFormVersion({ keyId }) {

    const {
        arrMonth,
        form,
    } = useContext(ProviderExpensePlan);

    const { control, setValue, watch, getValues, reset } = form;
    const { fields } = useFieldArray({
        control,
        name: "lstExpensePlanVersion"
    });

    const watchFieldArray = watch("lstExpensePlanVersion");

    const controlledFields = useMemo(() => {
        return fields.map((field, index) => {
            return {
                ...field,
                ...watchFieldArray[index]
            };
        });
    }, [fields, watchFieldArray])

    return (
        // <TableContainer id='table-pinned' component={Paper} sx={{ maxHeight: '500px' }}>
        <TableContainer id='table-pinned' sx={{ maxHeight: "80vh" }} component={Paper}>
            <Table stickyHeader sx={{ minWidth: 1400 }} >
                <TableHead>
                    <TableRow>
                        <TableCell className="sticky-cell pad-0 head-color head-z400" component="th" padding='none' style={{ minWidth: '470px', width: '470px' }}>
                            {/* <TableCell className='cell-in-sticky border-l head-color' padding='none' style={{ minWidth: '110px', width: '110px' }}></TableCell> */}
                            <TableCell className='cell-in-sticky border-l head-color' padding='none' style={{ minWidth: '60px', width: '60px' }}>ลำดับที่</TableCell>
                            <TableCell className='cell-in-sticky border-l head-color' padding='none' style={{ minWidth: '300px', width: '300px' }}>รายการ</TableCell>
                        </TableCell>
                        {
                            arrMonth.map((month: string, indexM: number) => {
                                let isFillColor = [3, 7, 11, 15].includes(indexM);
                                return (
                                    <TableCell
                                        key={month}
                                        component="th"
                                        padding='none'
                                        className={isFillColor ? 'head-z300' : "head-color head-z300"}
                                        sx={{
                                            minWidth: '150px',
                                            width: '150px',
                                            backgroundColor: isFillColor ? '#70b603 !important' : "head-color"
                                        }}
                                    >
                                        {month}
                                    </TableCell>
                                )
                            })
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        controlledFields != null && controlledFields.length > 0 ?
                            <>

                                {controlledFields.map((itemRowLevel1, indexLevel1) => {
                                    let keyCellTable = keyId + itemRowLevel1.nID;
                                    return (
                                        <Fragment key={keyCellTable}>
                                            <NestedArrayLevel1 keyId={keyId} itemRowLevel1={itemRowLevel1} indexLevel1={indexLevel1} {...{ control, reset, getValues, watch, setValue, }} />
                                        </Fragment>
                                    )
                                })}
                            </>
                            :
                            <TableRow key={"r-no-data"}>
                                <TableCell align="center" colSpan={20}>
                                    ไม่พบข้อมูล
                                </TableCell>
                            </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>

    )
}

function NestedArrayLevel1({ itemRowLevel1, indexLevel1, control, setValue, watch, reset, keyId }) {

    const {
        calIndexOld,
    } = useContext(ProviderExpensePlan);

    const { fields } = useFieldArray({
        control,
        name: `lstExpensePlanVersion.${indexLevel1}.lstSubLevel`
    });

    const watchFieldArray = watch(`lstExpensePlanVersion.${indexLevel1}.lstSubLevel`);
    const controlledFieldsLevel2 = useMemo(() => {
        return fields.map((field, index) => {
            return {
                ...field,
                ...watchFieldArray[index]
            };
        });

    }, [fields, watchFieldArray])


    return (
        <>
            <TableRow sx={{ backgroundColor: "#ffdbaa" }}>
                <TableCell className="sticky-cell pad-0" sx={{ backgroundColor: "#ffdbaa !important" }}>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}>{indexLevel1 + 1}</TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}>
                        {itemRowLevel1.sExpense}
                    </TableCell>
                </TableCell>
                {
                    !itemRowLevel1.lstExpenseMonth ? null :
                        itemRowLevel1.lstExpenseMonth.map((keyRow: { value: string | number; }, indexMonth: number) => {
                            return (
                                <>
                                    <TableCell
                                        padding='none'
                                    >
                                        <TextFieldInputNumber value={keyRow.value} digit={2} />
                                    </TableCell>
                                    {
                                        [2, 5, 8, 11].includes(indexMonth) ?
                                            <TableCell padding='none'>
                                                <TextFieldInputNumber value={itemRowLevel1["nQ" + calIndexOld(indexMonth)]} digit={2} />
                                            </TableCell>
                                            :
                                            null
                                    }
                                    {
                                        [11].includes(indexMonth) ?
                                            <TableCell
                                                padding='none'
                                            >
                                                <TextFieldInputNumber value={itemRowLevel1.nTotal} digit={2} />
                                            </TableCell>
                                            :
                                            null
                                    }
                                </>
                            )
                        })
                }
            </TableRow>
            {
                controlledFieldsLevel2.map((itemRowLevel2, indexLevel2) => {
                    let keyCellTable = keyId + itemRowLevel2.nID;
                    return (
                        <Fragment key={keyCellTable}>
                            <NestedArrayLevel23 itemRowLevel2={itemRowLevel2} indexLevel1={indexLevel1} indexLevel2={indexLevel2} keyId={keyId} {...{ control, setValue, watch, reset }} />
                        </Fragment>
                    )
                })
            }
        </>
    );
}

function NestedArrayLevel23({ itemRowLevel2, indexLevel1, indexLevel2, control, watch, keyId }) {

    const {
        calIndexOld,
    } = useContext(ProviderExpensePlan);

    const { fields } = useFieldArray({
        control,
        name: `lstExpensePlanVersion.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel`
    });

    const watchFieldArray = watch(`lstExpensePlanVersion.${indexLevel1}.lstSubLevel.${indexLevel2}.lstSubLevel`);

    const controlledFieldsLevel3 = useMemo(() => {
        return fields.map((field, index) => {
            return {
                ...field,
                ...watchFieldArray[index]
            };
        });

    }, [fields, watchFieldArray])

    return (
        <>
            <TableRow sx={{ backgroundColor: "#eae6e6" }}>
                <TableCell className="sticky-cell pad-0" padding='none' sx={{ backgroundColor: "#eae6e6 !important" }}>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}>{indexLevel1 + 1 + "." + (indexLevel2 + 1)}</TableCell>
                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}>
                        {itemRowLevel2.sExpense}
                    </TableCell>
                </TableCell>
                {
                    !itemRowLevel2.lstExpenseMonth ? null :
                        itemRowLevel2.lstExpenseMonth.map((keyRow: { value: string | number; }, indexMonth: number) => {
                            return (
                                <>
                                    <TableCell
                                        padding='none'
                                    >
                                        <TextFieldInputNumber value={keyRow.value} digit={2} />
                                    </TableCell>
                                    {
                                        [2, 5, 8, 11].includes(indexMonth) ?
                                            <TableCell padding='none'>
                                                <TextFieldInputNumber value={itemRowLevel2["nQ" + calIndexOld(indexMonth)]} digit={2} />
                                            </TableCell>
                                            :
                                            null
                                    }
                                    {
                                        [11].includes(indexMonth) ?
                                            <TableCell
                                                padding='none'
                                            >
                                                <TextFieldInputNumber value={itemRowLevel2.nTotal} digit={2} />
                                            </TableCell>
                                            :
                                            null
                                    }
                                </>
                            )
                        })
                }
            </TableRow>
            {
                controlledFieldsLevel3.map((itemRowLevel3, indexLevel3) => {
                    let keyCellTable = keyId + itemRowLevel3.nID;
                    return (
                        <Fragment key={keyCellTable}>
                            <TableRow >
                                <TableCell className="sticky-cell pad-0" padding='none' sx={{ backgroundColor: "#ffffff !important" }}>
                                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}>
                                        {itemRowLevel3.sExpense}
                                    </TableCell>
                                </TableCell>
                                {
                                    !itemRowLevel3.lstExpenseMonth ? null :
                                        itemRowLevel3.lstExpenseMonth.map((keyRow: { value: string | number; name: string; }, indexMonth: number) => {
                                            return (
                                                <>
                                                    <TableCell
                                                        padding='none'
                                                    >
                                                        <TextFieldInputNumber value={keyRow.value} digit={2} />
                                                    </TableCell>
                                                    {
                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                            <TableCell padding='none'>
                                                                <TextFieldInputNumber value={itemRowLevel3["nQ" + calIndexOld(indexMonth)]} digit={2} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        [11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                            >
                                                                <TextFieldInputNumber value={itemRowLevel3.nTotal} digit={2} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )
                                        })
                                }
                            </TableRow>
                        </Fragment>
                    )
                })
            }
        </>
    );
};

